module.exports = __webpack_public_path__ + "img/19.1db027e5.jpg";